import React from 'react';

export type TemplateWatcherContextValue = {
  pendingCount: number;
  hasStalePending: boolean;
  manualSync: () => Promise<void>;
};

const TemplateWatcherContext = React.createContext<TemplateWatcherContextValue | null>(null);

export function TemplateWatcherProvider({
  value,
  children,
}: {
  value: TemplateWatcherContextValue;
  children: React.ReactNode;
}) {
  return <TemplateWatcherContext.Provider value={value}>{children}</TemplateWatcherContext.Provider>;
}

export function useTemplateWatcherControls(): TemplateWatcherContextValue | null {
  return React.useContext(TemplateWatcherContext);
}
